import { render, staticRenderFns } from "./DeletedIncidentTab.vue?vue&type=template&id=7709ef60"
import script from "./DeletedIncidentTab.js?vue&type=script&lang=js&external"
export * from "./DeletedIncidentTab.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports